import { render, staticRenderFns } from "./ProductListHorizontalCards.vue?vue&type=template&id=c3ec9b1c&scoped=true&"
import script from "./ProductListHorizontalCards.vue?vue&type=script&lang=js&"
export * from "./ProductListHorizontalCards.vue?vue&type=script&lang=js&"
import style0 from "./ProductListHorizontalCards.vue?vue&type=style&index=0&id=c3ec9b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ec9b1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
